import { env } from '../../env';
import { AppUrl } from '../../helpers/clientConfigs';

export const openRules = (rulesPath: string) => {
  if (window.cordova) {
    window.cordova.InAppBrowser.open(AppUrl + rulesPath, '_system', 'location=yes');
  } else {
    if (env.PUBLIC_URL) {
      window.open(env.PUBLIC_URL + rulesPath, '_blank');
    } else {
      window.open(rulesPath, '_blank');
    }
  }
};
